import { getCurrentInstance, inject, Ref } from "vue";

import { TRANSLATE_LANGUAGE_KEY } from "../directives/translate";
import { translate as i18nTranslate, ValueDictionary } from "../i18n";

export function useTranslate() {
  const instance = getCurrentInstance();
  let language: Ref<string> | null = null;

  if (instance) {
    language = inject<Ref<string> | null>(TRANSLATE_LANGUAGE_KEY, null);
  }

  return (key: string, values?: ValueDictionary): string => {
    if (language) {
      void language.value; // Create reactive dependency
    }
    return i18nTranslate(key, values);
  };
}
